;(function( $, window, document, undefined ){

  var CodeElement = function( elem, options ){
      this.elem = elem;
      this.$elem = $(elem);
      this.options = options;

    };

  // the plugin prototype
  CodeElement.prototype = {
    defaults: {
      message: 'Code Enabled'
    },

    init: function() {
      this.config = $.extend({}, this.defaults, this.options,
      this.metadata);

      this.setupCodeCopy();

      return this;
    },

    setupCodeCopy: function() {
      this.$elem.on('click', '.code-copy-button', function(event) {
        event.preventDefault();

        var text = $(this).closest('.code-element').find('.code-text-only').html();
        var $buildCode = $(this).closest('.code-element');

        var input = document.createElement('textarea');
        $buildCode.append(input);
        //copy text, and unencode the encoded lt and gt tags.
        input.value = text.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
        input.focus();
        input.select();

        var succeeded;
        try {
          succeeded = document.execCommand("copy");
          input.remove();
        } catch (e) {
          succeeded = false;
        }

        if (succeeded) {
          $(this).text("Copied!");
        } else {
          $(this).text("Error!");
        }

        input.remove();

        return false;
      });
    }

  };


  CodeElement.defaults = CodeElement.prototype.defaults;

  $.fn.codeElement = function(options) {
    return this.each(function() {
      new CodeElement(this, options).init();
    });
  };

})( jQuery, window , document );
